import axios from "axios";

// Use relative URL - will be proxied to http://localhost:5000
const API_URL = "/api/v1";

console.log("🚀 API URL:", API_URL);
console.log("📡 Using proxy:", "http://localhost:5000");

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 30000,
});

const restoreAdminSupportSession = () => {
  const adminToken = sessionStorage.getItem("support-session-admin-token");
  const adminUser = sessionStorage.getItem("support-session-admin-user");
  if (!adminToken || !adminUser) return false;

  sessionStorage.removeItem("support-session-admin-token");
  sessionStorage.removeItem("support-session-admin-user");
  localStorage.setItem("token", adminToken);
  localStorage.setItem("user", adminUser);
  window.location.href = "/admin";
  return true;
};

const isPublicAuthRequest = (url = "") =>
  /^\/auth\/(?:login|register|verify-email|resend-verification|forgot-password|reset-password)(?:\?|$)/.test(
    url,
  );

const isPublicAuthPage = () =>
  /^\/(?:login|register|forgot-password|verify-email|reset-password(?:\/|$))/.test(
    window.location.pathname,
  );

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log(
      `📤 ${config.method.toUpperCase()} ${config.baseURL}${config.url}`,
    );
    return config;
  },
  (error) => {
    console.error("📤 Request Error:", error);
    return Promise.reject(error);
  },
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    console.log(`📥 ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    if (error.code === "ECONNABORTED") {
      console.error("⏱️ Request timeout");
    }

    if (error.response) {
      console.error("📥 Response Error:", error.response.status);
      console.error("Response data:", error.response.data);
    } else if (error.request) {
      console.error("❌ No response from server");
      console.error("Make sure backend is running on port 5000");
      console.error("Try: curl http://localhost:5000/health");
    }

    if (
      error.response?.status === 403 &&
      error.response?.data?.requiresPasswordChange
    ) {
      if (window.location.pathname !== "/change-temporary-password") {
        window.dispatchEvent(new Event("auth:password-change-required"));
      }
    } else if (
      error.response?.status === 401 &&
      !isPublicAuthRequest(error.config?.url)
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (!restoreAdminSupportSession() && !isPublicAuthPage()) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
